// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rhKZS","label":"styles_label__etW7H","select":"styles_select__0YuX+"};